export default {"src":"/_next/static/media/diners-club.e581f14f.svg","height":512,"width":512};